import type { infer as zInfer } from "zod";
import * as z from "zod";

export const getBigcommerceIntegration = {
  name: "getBigcommerceIntegration" as const,
  input: z.object({}),
  output: z.union([
    z.object({
      exchangeOrderStatus: z.number(),
      enabled: z.boolean().nullish(),
      refundMethod: z.enum(["default", "noop"]),
      storeCredit: z.enum(["gift_card", "store_credit"]),
    }),
    z.undefined(),
  ]),
};

export type BigcommerceIntegration = zInfer<
  typeof getBigcommerceIntegration.output
>;
